import React from "react";
import '../../components/Skeletons/Dashboard_Skeleton.css';

const DashboardSkeleton = ({ isSidebarOpen }) => {
  const mainColClass = isSidebarOpen ? "col-xl-10 pr-0" : "col-xl-9 pr-0";
  const sideColClass = isSidebarOpen ? "col-xl-2" : "col-xl-3";

  // 1. Helper style for internal bars to make them fully rounded "pills"
  const pillStyle = { borderRadius: "50px" };
  
  // 2. Helper style for the card corners
  const cardRadius = "20px";

  return (
    <div className="container-fluid">
      <div className="row mt-2 mx-0">
        
        {/* --- MAIN COLUMN (KPIs + Feeds) --- */}
        <div className={`col-12 col-lg-8 ps-0 pe-0 pe-lg-2 ${mainColClass}`}>
          
          {/* 1. KPI Cards Skeleton (Row of 6) */}
          <div className="row mb-3">
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <div key={item} className="col-md-2 col-sm-6 mb-6">
                <div className="skeleton-card" style={{ height: "120px", borderRadius: cardRadius }}>
                  <div className="skeleton-box" style={{ width: "40%", height: "15px", marginBottom: "10px", ...pillStyle }}></div>
                  <div className="skeleton-box" style={{ width: "80%", height: "30px", ...pillStyle }}></div>
                </div>
              </div>
            ))}
          </div>

          {/* 2. Tabs Skeleton (Highly Curved Top Corners) */}
          <div className="row mx-0 mb-0">
            <div className="col-12 px-0 d-flex align-items-end">
              {/* Tab 1: Active-like */}
              <div 
                className="skeleton-box me-1" 
                style={{ 
                  flex: 1, 
                  height: "45px", 
                  borderRadius: "20px 20px 0 0", // Very curved top
                  marginBottom: "-1px", 
                  zIndex: 1
                }}
              ></div>
              {/* Tab 2: Inactive */}
              <div 
                className="skeleton-box me-1" 
                style={{ 
                  flex: 1, 
                  height: "45px", 
                  borderRadius: "20px 20px 0 0", // Very curved top
                  opacity: 0.7 
                }}
              ></div>
              {/* Tab 3: Inactive */}
              <div 
                className="skeleton-box" 
                style={{ 
                  flex: 1, 
                  height: "45px", 
                  borderRadius: "20px 20px 0 0", // Very curved top
                  opacity: 0.7 
                }}
              ></div>
            </div>
          </div>

          {/* 3. Feeds Skeleton (Connected with Curved Bottom) */}
          <div 
            className="skeleton-card" 
            style={{ 
                borderTopLeftRadius: 0, 
                borderTopRightRadius: 0, 
                borderRadius: `0 0 ${cardRadius} ${cardRadius}` // Curves the bottom of the feed container
            }}
          >
            {[1, 2].map((i) => (
              <div key={i} className="mb-4 pb-3 border-bottom">
                <div className="d-flex align-items-center mb-3">
                  <div className="skeleton-box skeleton-circle" style={{ width: "50px", height: "50px", marginRight: "15px" }}></div>
                  <div className="w-100">
                    <div className="skeleton-box mb-2" style={{ width: "30%", height: "15px", ...pillStyle }}></div>
                    <div className="skeleton-box" style={{ width: "20%", height: "12px", ...pillStyle }}></div>
                  </div>
                </div>
                <div className="skeleton-box mb-2" style={{ width: "100%", height: "15px", ...pillStyle }}></div>
                <div className="skeleton-box mb-2" style={{ width: "90%", height: "15px", ...pillStyle }}></div>
                <div className="skeleton-box mb-3" style={{ width: "60%", height: "15px", ...pillStyle }}></div>
                <div className="skeleton-box" style={{ width: "100%", height: "200px", borderRadius: cardRadius }}></div>
              </div>
            ))}
          </div>
        </div>

        {/* --- SIDE COLUMN (Widgets) --- */}
        <div className={`col-12 col-lg-4 mt-3 mt-lg-0 ps-0 ps-lg-2 pe-0 ${sideColClass}`}>
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className="skeleton-card mb-3" style={{ height: "250px", borderRadius: cardRadius }}>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="skeleton-box" style={{ width: "40%", height: "20px", ...pillStyle }}></div>
                <div className="skeleton-box" style={{ width: "10%", height: "20px", ...pillStyle }}></div>
              </div>
              
              {[1, 2, 3].map((line) => (
                <div key={line} className="d-flex align-items-center mb-3">
                   <div className="skeleton-box skeleton-circle" style={{ width: "40px", height: "40px", marginRight: "10px" }}></div>
                   <div className="skeleton-box" style={{ width: `${80 - line * 10}%`, height: "15px", ...pillStyle }}></div>
                </div>
              ))}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default DashboardSkeleton;